// Any config specific to LEBANON?

export default {
  code: 'LB',
  countryName: 'Lebanon',
  googleSiteVerificationCode: [
    'kanihyduaeRWrotFKPjt5utDrUw4Up9I7-i7T5FHNIo',
    'rahIimcw3bnE2R8op5VpCvO3GrUFhb5Chat8YJUcQjo',
    'qIcM63cgYScfL2-63ylDva2qsSU2yScxoI28vzBmivM'
  ],
  countryDomain: 'https://www.carrefourlebanon.com',
  helplineNumber: '+9611296300',
  latitude: 33.8892527,
  longitude: 35.4867727,
  countryFlagIcon: 'LB_ceafd0e11a.png',
  defaultAreaCode: 'Hazmieh - Baabda',
  features: {
    languageChange: false,
    now: false,
    share: false,
    isLocationCXEnable: false,
    cashback: true,
    linkMyClubCard: true,
    oneTrustScript: 'd9f0f857-1c33-4630-9c15-02907e499277'
  }
}
